import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { verifyEmail } from '../slices/AuthSlice';
import { showErrorToast } from '../slices/ToastNotificationSlice';
import { AppDispatch } from '../types';

import OneRealLogo from '../assets/img/auth/auth-one-real-logo.png';
import RealBrandLogo from '../assets/img/real-brand-logo-black-border.svg';
import ValidateEmailStatus, { VerificationStatus } from './ValidateEmailStatus';

interface ValidateEmailProps {}

const ValidateEmail: React.FC<ValidateEmailProps> = () => {
  const location = useLocation();
  const dispatch: AppDispatch = useDispatch();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');
  const isAgentContext = location.pathname === '/agent-validate-email';
  const [status, setStatus] = useState<VerificationStatus>(
    VerificationStatus.VERIFYING,
  );

  useEffect(() => {
    if (!token) {
      dispatch(showErrorToast('This link is invalid or expired.'));
      setStatus(VerificationStatus.NO_TOKEN);
      return;
    }

    const validateEmail = async () => {
      setStatus(VerificationStatus.VERIFYING);

      const isVerified = await dispatch(verifyEmail(token));
      if (isVerified) {
        setStatus(VerificationStatus.VERIFIED);
      } else {
        setStatus(VerificationStatus.INVALID_TOKEN);
      }
    };

    validateEmail();
  }, [token, dispatch]);

  return (
    <div className='lg:col-span-1 place-content-start lg:bg-none bg-no-repeat bg-contain bg-white h-screen py-4 relative'>
      <div className='lg:h-full auth-custom-scroll'>
        <div className='block px-4 lg:px-16 pt-6 lg:pt-16 pb-6'>
          <img
            src={isAgentContext ? RealBrandLogo : OneRealLogo}
            alt='placeholder'
            width={isAgentContext ? 90 : 170}
            height={50}
          />
        </div>
        <div className='flex flex-col items-center bg-white px-4 py-6 mx-4 rounded-xl lg:mt-20 lg:mb-20 mt-0'>
          <ValidateEmailStatus
            status={status}
            isAgentContext={isAgentContext}
          />
        </div>
      </div>
    </div>
  );
};

export default ValidateEmail;
